import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTemplateValidate = (docHash, body, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: templateKeys.validate(docHash, body.target_kind, body.subject, 'library' in body && body.library === true),
        queryFn: () => axios.post(markUrl('templates/validate/'), body, additional),
        enabled,
        staleTime: 30_000,
        placeholderData: keepPreviousData
    });
};
export default useTemplateValidate;
